"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JobStatusComponent = /** @class */ (function () {
    function JobStatusComponent() {
    }
    return JobStatusComponent;
}());
exports.JobStatusComponent = JobStatusComponent;
